import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'admin-ui', {
    // Pages
    adminActions: 'Admin Actions',
    eventDefinitions: 'Event Definitions',
    repoPackages: 'Repo Packages',
    sentryIssues: 'Sentry Issues',
    agentSession: '{{issueKey}} {{stage}} session',
    // Agent session page
    agentSessionLoading: 'Loading the session…',
    agentSessionNotFound: 'No pipeline run for {{issueKey}}.',
    agentSessionRunning: 'A turn is running. Refresh to read its latest messages.',
    agentSessionSettled: 'No turn is running. These are the last turn’s messages.',
    agentSessionRefresh: 'Refresh',
    agentSessionWatch: 'Watch the running turn',
    agentSessionNoMessages: 'The agent has said nothing yet.',
    // Admin actions
    seedDatabase: 'Seed Database',
    syncDatabaseConfirmDescription:
      'Are you sure you want to sync the database from {{source}}? This will overwrite existing configurations.',
    seedDatabaseConfirmDescription:
      'Are you sure you want to seed the database? This action cannot be undone.',
    migrateLegacyMetricsDryRun: 'Migrate Legacy Metrics (dry-run)',
    migrateLegacyMetricsDryRunConfirmDescription:
      "Read Erik's legacy Mongo metrics (LEGACY_MONGO_URL) and report what would be written for {{userId}}. No writes.",
    migrateLegacyMetricsExecute: 'Migrate Legacy Metrics (execute)',
    migrateLegacyMetricsExecuteConfirmDescription:
      "Write Erik's legacy Mongo metrics into Neon for {{userId}}. Idempotent via sourceId; cannot undo easily.",
    migrateLegacyMetricsTargetUserIdTitle: 'Target Neon user',
    migrateLegacyMetricsTargetUserIdDescription:
      'Neon User.id that should receive the imported MetricValue / UserMetric rows.',
    migrateLegacyMetricsTargetUserIdLabel: 'User id',
    migrateLegacyMetricsTargetUserIdCancel: 'Cancel',
    migrateLegacyProgramsDryRun: 'Migrate Legacy Programs (dry run)',
    migrateLegacyProgramsDryRunConfirmDescription:
      'Read legacy Mongo programs (LEGACY_MONGO_URL), apply import rules, and log counts. No Neon writes.',
    migrateLegacyProgramsExecute: 'Migrate Legacy Programs (execute)',
    migrateLegacyProgramsExecuteConfirmDescription:
      'Import published programs and Erik legacy-authored drafts into admin-owned Program rows. Idempotent on legacyId.',
    seedTestPrograms: 'Seed Test Programs',
    seedTestProgramsConfirmDescription:
      'Insert the three hand-designed test programs as admin-owned, published programs (skips existing handles unless you add ?reset=1 to the API URL).',
    syncDbFromPrev: 'Sync DB from Prev',
    deleteOrphanedDelegateItems: 'Delete Orphaned Delegate Items',
    deleteOrphanedDelegateItemsConfirmDescription:
      'Delete OwnedItem, NamedItem, ResourceItem, and ConnectionItem rows that have no matching concrete-table row?',
    embedTaxonomy: 'Embed Taxonomy',
    embedTaxonomyConfirmDescription:
      'Are you sure you want to run the embed taxonomy job? This will compute embeddings for un-embedded taxonomy items.',
    sendNotification: 'Send Notification',
    deploySuprSendWorkflowsTitle: 'Deploy SuprSend Workflows',
    deploySuprSendWorkflowsConfirmDescription:
      'Are you sure you want to deploy SuprSend templates and workflows from Development to {{targetEnv}}?',
    closeStaleConvos: 'Close stale convos',
    convertHabitRecurDays: 'Convert Habit Recur Days',
    convertHabitRecurDaysConfirmDescription:
      'Are you sure you want to convert habit recurrence days from 7-character format to comma-separated format?',
    startSentryProfilerClient: 'Start Sentry profiler (client)',
    stopSentryProfilerClient: 'Stop Sentry profiler (client)',
    startSentryProfilerServer: 'Start Sentry profiler (server)',
    stopSentryProfilerServer: 'Stop Sentry profiler (server)',
    sentryProfilerStartedClient: 'Sentry profiler started (client)',
    sentryProfilerStoppedClient: 'Sentry profiler stopped (client)',
    // User grid — group actions
    repairSelectedUsers: 'Repair selected users',
    repairUserJourneys: 'Repair user journeys',
    resetUserData: 'Reset user data',
    updateUsersInSuprSend: 'Update users in SuprSend',
    sendNotifications: 'Send notifications',
    trashSelectedUsers: 'Trash selected users',
    // User grid — row actions
    editUser: 'Edit user',
    userProfile: 'User profile',
    generateApiToken: 'Generate API token',
    repairUser: 'Repair user',
    repairUserJourney: 'Repair user journey',
    updateUserInSuprSend: 'Update user in SuprSend',
    sendNotificationRow: 'Send notification',
    trashUser: 'Trash user',
    deleteUser: 'Delete user',
    // User grid — columns
    emailVerified: 'Email verified',
    // User grid — confirm / snack / dialog copy
    trashUserConfirmDescription:
      'Are you sure you want to send the user {{userName}} to the trash?',
    userMovedToTrash: 'User moved to the trash',
    deleteUserConfirmDescription:
      'Permanently delete user {{userName}}? This cannot be undone and will remove the user and their data.',
    userDeleted: 'User deleted',
    tokenNameLabel: 'Token name',
    generateApiTokenDialogTitle: 'Generate API Token',
    generateApiTokenDialogDescription: 'Enter a name for this token (for example "My MCP Token")',
    apiTokenOpenedInNewTab: 'Opened token response in a new tab; copy data.token from the JSON.',
    repairUserDialogTitle: 'Repair User',
    repairUserConfirmDescription: 'Are you sure you want to repair the user {{userName}}?',
    repairUserJourneyStepDialogTitle: 'Repair User Journey Step',
    repairUserJourneyStepConfirmDescription:
      'Are you sure you want to calculate and update the journey step for user {{userName}}?',
    resetUserDataDialogTitle: 'Reset User Data',
    updateUserInSuprSendDialogTitle: 'Update User in SuprSend',
    updateUserInSuprSendConfirmDescription:
      'Are you sure you want to update the user {{userName}} in SuprSend with the latest data from our database?',
    // User grid — group action confirm building blocks
    actionVerbTrash: 'Trash',
    actionVerbRepair: 'Repair',
    actionVerbReset: 'Reset',
    actionVerbUpdate: 'Update',
    actionVerbSend: 'Send',
    nounUser: 'User',
    nounUsers: 'Users',
    nounUserJourney: 'User Journey',
    nounUserJourneys: 'User Journeys',
    nounUserInSuprSend: 'User in SuprSend',
    nounUsersInSuprSend: 'Users in SuprSend',
    nounNotification: 'Notification',
    nounNotifications: 'Notifications',
    resetUserDataDescriptionSuffix:
      ' This will clear all profile information and delete all Factoids and Quiz Results. This action cannot be undone.',
    usersMovedToTrash: '{{count}} user moved to trash',
    usersMovedToTrash_plural: '{{count}} users moved to trash',
    // Repo package grid
    repoReviewStarted: 'Repo review started: {{packageName}} / {{reviewSlug}}',
  });
}
